import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { matchPath } from 'react-router';
import Paths from 'AppPaths';
import AdminList from 'components/team/AdminList';
import { Button } from '@shoflo/polymer/components/Button/Button';
import { showModal } from 'actions';

import {
  getTeamMembers,
  resendInviteInCurrentTeam,
  deleteAdminInCurrentTeam
} from 'actions/Team';

function Unconnected({
  user,
  showModal,
  getTeamMembers,
  teamMembers,
  teamId,
  resendInvite,
  deleteAdmin,
  isLoading
}) {
  useEffect(() => {
    if (teamId) {
      getTeamMembers();
    }
  }, [getTeamMembers, teamId]);

  return (
    <div>
      <AdminList
        inviteCrewButton={
          <Button
            data-testid="inviteTeamAdmin"
            color="primary"
            onClick={showModal.bind(null, 'TEAM_INVITE_ADMINS')}
          >
            Invite team admins
          </Button>
        }
        onDeleteClick={deleteAdmin}
        onResendInviteClick={resendInvite}
        users={teamMembers}
        currentUserId={user._id}
        isLoading={isLoading}
      />
    </div>
  );
}

const PropMapper = (
  { selectedTeamMembers, isDataLoading, user },
  { match }
) => {
  const teamMatch = matchPath(match.url, {
    path: Paths.TeamDash
  });

  const teamId = teamMatch ? teamMatch.params.teamId : null;

  return {
    user,
    teamId,
    teamMembers: selectedTeamMembers,
    isLoading: isDataLoading
  };
};

export default connect(PropMapper, {
  showModal,
  getTeamMembers,
  resendInvite: resendInviteInCurrentTeam,
  deleteAdmin: deleteAdminInCurrentTeam
})(Unconnected);

export { Unconnected, PropMapper };
